import { useQuery } from "../../Utils/utils"

export const usePageQuery = (search) => {
  const query = useQuery(search)
  return {
    openLinkID: query.get("open_link")
  }
}
